module.exports = __webpack_public_path__ + "img/contra_file.a63f57aa.png";